import React, { memo } from 'react';
import ReactLoading, { LoadingProps } from 'react-loading';

import styles from './LoadingComponents.module.scss';

type Props = { options?: LoadingProps };

const LoadingSpinner: React.FC<React.PropsWithChildren<Props>> = ({ options }) => {
  const loadingProperties: LoadingProps = {
    // id: 'content-loading-spinner',
    className: styles.spinner,
    color: '#0098ff',
    height: '5rem',
    type: 'spin',
    width: '5rem',
    ...options,
  };

  return <ReactLoading {...loadingProperties} />;
};

export default memo(LoadingSpinner);
